document.addEventListener('DOMContentLoaded', function () {
  const quizRoot = document.getElementById('bh-quiz');
  if (!quizRoot) return;

  let bothHairUrl = '';
  let bothSkinUrl = '';
  let pendingResultUrl = '';
  let resultType = '';

  function showStep(stepId) {
    const steps = quizRoot.querySelectorAll('.bh-quiz-step');
    steps.forEach((step) => step.classList.remove('is-active'));

    const nextStep = document.getElementById(stepId);
    if (nextStep) {
      nextStep.classList.add('is-active');
      nextStep.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  document.addEventListener('click', function (event) {
    const startBtn = event.target.closest('#bh-start-quiz');
    if (startBtn) {
      event.preventDefault();
      showStep('bh-step-2');
      return;
    }

    const backBtn = event.target.closest('.bh-quiz__back');
    if (backBtn) {
      event.preventDefault();
      const backStep = backBtn.getAttribute('data-back-step');
      if (backStep) showStep(backStep);
      return;
    }

    const choiceBtn = event.target.closest('[data-choice]');
    if (choiceBtn) {
      event.preventDefault();
      const choice = choiceBtn.getAttribute('data-choice');

      if (choice === 'hair') showStep('bh-step-hair');
      if (choice === 'skin') showStep('bh-step-skin');
      if (choice === 'both') showStep('bh-step-both-hair');

      return;
    }

    const directResultBtn = event.target.closest('[data-result-url]');
    if (directResultBtn) {
      event.preventDefault();

      pendingResultUrl = directResultBtn.getAttribute('data-result-url') || '';
      resultType = 'direct';

      showStep('bh-step-email');
      return;
    }

    const bothHairBtn = event.target.closest('[data-both-hair]');
    if (bothHairBtn) {
      event.preventDefault();

      bothHairUrl = bothHairBtn.getAttribute('data-both-hair') || '';
      showStep('bh-step-both-skin');
      return;
    }

    const bothSkinBtn = event.target.closest('[data-both-skin]');
    if (bothSkinBtn) {
      event.preventDefault();

      bothSkinUrl = bothSkinBtn.getAttribute('data-both-skin') || '';
      resultType = 'both';

      showStep('bh-step-email');
      return;
    }
  });

  const emailForm = document.getElementById('bh-quiz-email-form');
  const emailInput = document.getElementById('bh-email-input');
  const emailError = document.getElementById('bh-email-error');

  if (emailForm) {
    emailForm.addEventListener('submit', function (event) {
      event.preventDefault();
      event.stopPropagation();

      const email = emailInput ? emailInput.value.trim() : '';
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (!emailRegex.test(email)) {
        if (emailError) emailError.style.display = 'block';
        return false;
      }

      if (emailError) emailError.style.display = 'none';

      const formData = new FormData();
      formData.append('form_type', 'customer');
      formData.append('utf8', '✓');
      formData.append('contact[email]', email);
      formData.append('contact[tags]', 'quiz, Bella Hue Quiz');

      fetch('/contact', {
        method: 'POST',
        body: formData,
        credentials: 'same-origin'
      }).finally(function () {
        if (resultType === 'direct' && pendingResultUrl) {
          window.location.href = pendingResultUrl;
          return;
        }

        if (resultType === 'both') {
          const hairLink = document.getElementById('bh-hair-result-link');
          const skinLink = document.getElementById('bh-skin-result-link');

          if (hairLink) hairLink.href = bothHairUrl;
          if (skinLink) skinLink.href = bothSkinUrl;

          showStep('bh-step-both-results');
        }
      });

      return false;
    });
  }
});